import { Component } from '@angular/core';

@Component({
    selector: 'sgt-objetivo-campanha-badge-aquisicao',
    templateUrl: './objetivo-campanha-badge-aquisicao.component.html',
    styleUrls: ['./objetivo-campanha-badge-aquisicao.component.less']
})
export class ObjetivoCampanhaBadgeAquisicaoComponent {

}
